// Where the Home button goes (#4168).
//
// The `directToMemberPlan` team option sends a MEMBER-role member to their own plan instead of the
// team plan. That only makes sense for a member who IS on the plan: a member with showOnPlan off
// has no row, so their personal plan is empty — the worst of the two destinations.
//
// The login redirect in App.jsx has always guarded on showOnPlan; the three Home buttons (LIMS,
// the plan toolbar, Librarian) did not, so pressing Home landed a hidden member — which, since
// #4154, is what a QA member is by default — on that empty plan. One helper so the rule cannot
// drift between the four places that apply it.
export default function homePath({ isMember, directToMemberPlan, memberId, showOnPlan }) {
  if (isMember && directToMemberPlan && memberId && showOnPlan === true) {
    return `/member/${memberId}`
  }
  return "/"
}
